import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import DataWrapper from '../../../principal/containers/DataWrapper';
import TriagemDepotStore from "../stores/TriagemDepotStore";
import Footer from "../../../comum/components/Footer";
import { Container,Row, Col, Button, Label,InputGroup } from "reactstrap";
import FooterContent from '../../../comum/components/FooterContent';
import { TabelaTriagemDepot } from '../components/TabelaTriagemDepot';
import { CardInformacaoDados } from '../components/cardInformacaoDados';
import { getMesTexto } from "../../../../utils/functions";

import Card from '../../../comum/components/Card';
import InputFiltro from '../../../comum/components/InputFiltro';
import { buscaFiltrarVazio, buscaSemResultado, filtrosVaziosContainer } from "../../../../utils/mensagens";
import ModalAviso from "../../../comum/components/ModalAviso";
import ModalForm from '../../../comum/components/ModalForm'
import FooterModal from "../../../comum/components/FooterModal"
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import { IconeCarregar } from '../../../comum/components/Icones';
import LoadingImage from "../../../comum/components/LoadingImage";


@inject("store")
@DataWrapper
@observer
export class TriagemDepot extends Component {

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.controller = new TriagemDepotStore();
        this.getScreenSize()
        this.state = {
            refreshBooking : false,
            refreshContainer : false
        }
    }

    atualizaTabela = async () => {
        await this.controller.itensOrdemInicial();

    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Consulta Depot");
        this.appStore.showTopbar(true);
    }

    atualizaContainer = () => {
        setTimeout(() => {
            this.setState({refreshBooking: false, refreshContainer : false });
        }, 1000);
        return <div></div>
    };

    getScreenSize = () => {
        var w = window.innerWidth;
        var h = window.innerHeight;

        console.log('ta entrando ?', w, h);
        if (h <= 915) {
            return this.controller.isMobile = true;;
        } else {
            return  this.controller.isMobile = false;
        }
       
    }

    situacaoFormatter = (cell, row) => {
        if (!cell) return null;
    
        let classe = cell.toLowerCase().replace(/\s|\./g, '-');
        classe = classe.replace('--', '-');
        if (cell.toLowerCase() === "fora do terminal") {
            cell = "Fora term."
        }
    
        return <div className={`situacao-btn ${classe + ' pixMaior'}`}>{cell}</div>;
    
    };

  
    retornaMobileComponent = () => {
        console.log('retorna mobile', this.controller.veiculos)
        if (this.controller.isMobile) {
            if (this.controller.veiculos.length > 0) {
                return (
                    this.controller.loadingVeiculos ?  <LoadingImage />  : <CardInformacaoDados  controller={this.controller} />
                )
            } else {
                return (
                    this.controller.loadingVeiculos ?  <LoadingImage />  : <div className="anuncioFont">Não há dados</div>
                )   
            } 
       }
    }

    aviso = () => {
        if (this.controller.avisoOn)
            return <ModalAviso onClickFechar={() => { this.controller.avisoOn = false; this.controller.msg = "" }}>
                    <h2>{ this.controller.msg }</h2>
            </ModalAviso>
    };

    data = (data) => { 
        if (data === null) return "---";
        let dataFormatada;
        if (data) {
            let parsedData = new Date(data);
    
            if (!isNaN(parsedData)) {
                let d = parsedData.getDate();
                if (d < 10) d = "0" + d;
    
                let m = getMesTexto(parsedData.getMonth() + 1);
                console.log('data', d, m,  parsedData.getFullYear())
                dataFormatada = d+"/"+m+"/"+parsedData.getFullYear();
            }
        }
        
        console.log('data formatada', dataFormatada);
        return dataFormatada;
        
    }


    modalSearch() {
        if (this.controller.isMobile) {
            if (this.controller.searchModalON)
                {
                console.log('dados', this.controller.modalDados)
                    if (this.controller.modalDados != null) {
                        return (<ModalContainer zIndex={100}>
                            <ModalDialog className={"nosso-modal modal-margin item"}>
                                <div className={"buttt"}>
                                    <Button className={"btn btn-danger"} onClick={() => {this.controller.searchModalON = false}}>X</Button>
                                </div>
                                <div fluid>
                                    <div className="card "> 
                                        <div className="filtros">
                                            <Row className="align-items-end">
                                            <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom ">
                                                <Label className="card-Item-alling font-st">Tipo:</Label>
                                            </Col>
                                            <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom marginItem">
                                                <Label className="card-Item-alling ">{this.controller.modalDados.DscTipo}</Label>
                                            </Col>
                                            <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom ">
                                                <Label className="card-Item-alling font-st">Data e Hora:</Label>
                                            </Col>
                                            <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom marginItem">
                                                <Label className="card-Item-alling">{this.data(this.controller.modalDados.Data) + " - " + this.controller.modalDados.Hora + ":00"}</Label>
                                            </Col>
                                            <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom ">
                                            <Label className="card-Item-alling font-st">Placa:</Label>
                                            </Col>
                                            <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom marginItem">
                                                <Label className="card-Item-alling ">{ this.controller.modalDados.Placa}</Label>
                                            </Col>  <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom ">
                                                <Label className="card-Item-alling font-st">Armador:</Label>
                                            </Col>
                                            <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom marginItem">
                                                <Label className="card-Item-alling ">{this.controller.modalDados.ApelidoArmador}</Label>
                                            </Col>
                                            {this.controller.modalDados.TipoAgendId != 286 ? <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom ">
                                                <Label className="card-Item-alling font-st">Booking:</Label>
                                            </Col> : ""}
                                            {this.controller.modalDados.TipoAgendId != 286 ? <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom marginItem">
                                                <Label className="card-Item-alling ">{ this.controller.modalDados.LstBookings}</Label>
                                            </Col> : ""}  {this.controller.modalDados.TipoAgendId == 286 ? <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom ">
                                                <Label className="card-Item-alling font-st">Container:</Label>
                                            </Col> : ""}
                                            {this.controller.modalDados.TipoAgendId == 286 ?  <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom marginItem">
                                                <Label className="card-Item-alling">{ this.controller.modalDados.LstCntrs}</Label>
                                            </Col> : ""}
                                            <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom ">
                                                <Label className="card-Item-alling font-st">Situação</Label>
                                            </Col>
                                            <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom marginItem">
                                                <Label className="card-Item-alling">{ this.situacaoFormatter(this.controller.modalDados.StatusAgendamento)}</Label>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </ModalDialog>
                    </ModalContainer>)
                }
            }
        }
    }

    render() {
        
        window.addEventListener('resize',() => this.getScreenSize());

        let BuscaVaziaMsg

        if (this.controller.buscaVazia) {
            BuscaVaziaMsg = buscaSemResultado
        } else if (this.controller.buscaSemParametro) {
            BuscaVaziaMsg = filtrosVaziosContainer
        } else {
            BuscaVaziaMsg = ""
        }

        let exibirPaginacao = this.controller.numeroPaginas > 1;
        let Paginacao = exibirPaginacao ? <Paginação controller={this.controller} /> : "";
       
       console.log('asp', this.controller.veiculos)

        return (
            <div>
            <div className="marginData">
                <Container fluid>
                    {this.aviso()}
                    {this.modalSearch()}
                    <Card>
                        <div className="filtros">
                            <Row className="align-items-end">

                                <InputFiltro className="mb-1" titulo="Placa" xl={3} sm={6} xs={12}
                                    uppercase={true}
                                    onEnter={() => this.controller.listar()}
                                    onChange={e => this.controller.adicionarFiltro(e.target.value)}
                                />

                                <Col xl={3} sm={6} xs={12} className="mb-1 justify-content-start align-bottom">
                                        <Button onClick={ () => this.controller.listar()} className="btn-com-bordas-primary btn-filtrar">Filtrar</Button>
                                </Col>
                            </Row>
                        </div>
                    </Card>
                </Container>
                <Container fluid>
                    {this.controller.loading ?
                        <IconeCarregar tamanho="2x" /> :
                        <React.Fragment>
                            <Row className="mt-4">
                                {this.controller.filtrado
                                    ? this.controller.listarAgendamentos()
                                    :
                                    <Col xs={12}>
                                        <span className="mensagem-filtrar">
                                            {BuscaVaziaMsg === "" && buscaFiltrarVazio}
                                        </span>
                                    </Col>
                                }
                            </Row>
                            <div className="mensagem-aviso">
                                {BuscaVaziaMsg}
                            </div>
                            {Paginacao}
                        </React.Fragment>
                    }
                </Container>
            </div>
            <div className="box-valor23">
                <div >
                    <Container fluid>
                            {this.state.refreshContainer ? this.atualizaContainer() : this.retornaMobileComponent()}
                            {
                                !this.controller.isMobile && <TabelaTriagemDepot controller={this.controller} />
                            }
                    </Container>
                </div>

                <Footer>
                    <FooterContent>
                        {this.controller.total !== null &&
                            <div className="justify-content-between">
                                <div>
                                    <b>{this.controller.veiculos.length}</b> {this.controller.total === 1 ? 'registro' : 'registros'} -
                                <a onClick={() => this.controller.listarVeiculos()}>Atualizar Lista</a>
                                </div>
                            </div>
                        }
                    </FooterContent>
                </Footer>
            </div>
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/consultas/triagem-depot/telas/TriagemDepot.js